import events from './event.js';

class TextParser {
    static rows(element, linkCallback = null) {
        if (!element || !element.innerHTML) return;

        let html = element.innerHTML;

        // 1. Normalisera citationstecken
        html = html.replace(/&quot;/g, '"');
        html = html.replace(/[“”„‟″]/g, '"');

        // 2. Om vi har [row], rensa <p> och </p> före och efter [row och [/row] samt [column och [/column]
        if (/\[row[^\]]*\]/.test(html)) {

            // 1. Ta bort <p> före öppnande tagg
            html = html.replace(/<p>\s*(?=\[(row|column)[^\]]*])/gi, '');

            // 2. Ta bort </p> direkt efter öppnande tagg
            html = html.replace(/(?<=\[(row|column)[^\]]*])\s*<\/p>/gi, '');

            // 3. Ta bort <p> före stängande tagg
            html = html.replace(/<p>\s*(?=\[\/(row|column)])/gi, '');

            // 4. Ta bort </p> direkt efter stängande tagg
            html = html.replace(/(?<=\[\/(row|column)])\s*<\/p>/gi, '');
        }

        // 3. Hantera [row] och [column] som vanligt
        html = html.replace(/\[row([^\]]*)](.*?)\[\/row]/gs, (match, rowAttrs, rowContent) => {
            const rowAttributes = this._parseAttributes(rowAttrs);
            const columnsHTML = this._parseColumns(rowContent.trim());
            return this._createRow(columnsHTML, rowAttributes);
        });

        // 4. Uppdatera <h1></h1> så att det blir:
        // <div class="mindstore-underlined-title"><h1>Text</h1></div>
        html = html.replace(/<h1>(.*?)<\/h1>/gs, (match, titleText) => {
            return `<div class="mindstore-underlined-title"><h3>${titleText.trim()}</h3></div>`;
        });

        // Sätt tillbaka HTML i elementet
        element.innerHTML = html;

        // 4. Kolla efter länkar i elementet
        this.link(element, linkCallback);
    }

    static _parseColumns(content) {
        return content.replace(/\[column([^\]]*)](.*?)\[\/column]/gs, (match, colAttrs, colContent) => {
            const attrs = this._parseAttributes(colAttrs);

            const columnClass = ['column', attrs.class].filter(Boolean).join(' ');
            attrs.class = columnClass;

            // if offset is defined, add it to the 

            const attrStr = this._attributesToString(attrs); // <- Inkluderar columns + offset

            return `<div ${attrStr}>${colContent.trim()}</div>`;
        });
    }

    static link(element, linkCallback, linkClass = '') {
        if (!element || !element.innerHTML) return;

        let html = element.innerHTML;

        // [link attr="..."]text[/link]
        html = html.replace(/\[link([^\]]*)](.*?)\[\/link]/gs, (match, attrStr, text) => {
            const attrs = this._parseAttributes(attrStr);

            // Kombinera klassnamn
            const combinedClass = [attrs.class, linkClass].filter(Boolean).join(' ');
            if (combinedClass) attrs.class = combinedClass;

            const attrData = this._attributesToData(attrs);
            const cls = attrs.class ? ` class="${attrs.class}"` : '';

            return `<a href="#"${cls} data-link-text="${text.trim()}" ${attrData}>${text.trim()}</a>`;
        });

        // [kortform]
        html = html.replace(/\[([^\[\]\/]+?)\]/g, (match, text) => {
            const cls = linkClass ? ` class="${linkClass}"` : '';
            return `<a href="#"${cls} data-link-text="${text.trim()}">${text.trim()}</a>`;
        });

        element.innerHTML = html;

        // Klickhantering
        const links = element.querySelectorAll('a[data-link-text]');
        links.forEach(link => {
            link.addEventListener('click', event => {
                event.preventDefault();
                // const text = link.dataset.linkText;
                const attrs = {};
                for (const attr of link.attributes) {
                    if (attr.name.startsWith('data-attr-')) {
                        const name = attr.name.replace('data-attr-', '');
                        attrs[name] = attr.value;
                    }
                }

                if (linkCallback && typeof linkCallback === 'function') {
                    // Call the linkCallback with the attributes
                    const result = linkCallback(attrs);
                    // if the callback returns false, do not proceed
                    if (result === false) {
                        return;
                    }
                }

                // do default actions
                this._callback(attrs);
            });
        });
    }

    // === Intern standard callback (modifierbar) ===
    static _callback(attrs) {
        // if data-attr-step use navigate to step
        if (attrs.step) {
            events.trigger('closeAdditionalInfoPopup');
            events.trigger('changeStep', attrs.step);
        }
        if (attrs.activate == 'adjust') {
            events.trigger('toggleAdjustMode', true);
        }
        if (attrs.info !== undefined) {
            // If info is defined, open additional info popup
            events.trigger('openAdditionalInfoPopup', {
                text_prop_name: attrs.info + '_info_text'
            });
        }

        // Exempel: ignorera vissa ord
        // if (text.toLowerCase() === 'test') return false;

        // // Om text börjar med @, generera URL
        // if (text.startsWith('@')) {
        //     attrs.url = `/user/${text.slice(1)}`;
        //     return attrs.url;
        // }

        // // Om text är ett datum
        // if (/^\d{4}-\d{2}-\d{2}$/.test(text)) {
        //     return `/calendar/${text}`;
        // }

        return true;
    }

    static _createRow(innerColumnsHTML, attrs) {
        const rowClass = ['row', attrs.class].filter(Boolean).join(' ');
        attrs.class = rowClass;
        const attrStr = this._attributesToString(attrs);
        return `<div ${attrStr}>${innerColumnsHTML}</div>`;
    }

    static _parseAttributes(attrStr) {
        const attrs = {};

        // 1. Ersätt HTML-entitet &quot;
        attrStr = attrStr.replace(/&quot;/g, '"');

        // 2. Ersätt typografiska citationstecken + double prime
        attrStr = attrStr.replace(/[“”„‟″]/g, '"');

        // 3. Regex för nyckel="värde"
        const regex = /(\w+)\s*=\s*"([^"]*)"/g;
        let match;
        while ((match = regex.exec(attrStr))) {
            attrs[match[1]] = match[2];
        }

        return attrs;
    }

    static _attributesToData(attrs) {
        return Object.entries(attrs)
            .map(([key, val]) => `data-attr-${key}="${val}"`)
            .join(' ');
    }

    static _attributesToString(attrs, exclude = []) {
        return Object.entries(attrs)
            .filter(([key]) => !exclude.includes(key))
            .map(([key, val]) => `${key}="${val}"`)
            .join(' ');
    }
}

export default TextParser;